import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-shop',
  templateUrl: './general-shop.component.html',
  styleUrls: ['./general-shop.component.scss']
})
export class GeneralShopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
